import { Col, Row, Tooltip } from "antd";
import React, { useEffect, useState } from "react";
import { FaArrowRight, FaBus, FaChevronRight, FaExchangeAlt, FaHotel } from "react-icons/fa";
import { getPackageDomasticData } from "../../../services/holiday/holidayServices";
import { Link, useParams } from "react-router-dom";
import imageConfig from "../../../config/imageConfig";
import { getImageUrl } from "../../../utils/Constants";

const AffordableDomesticHolidays = () => {
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [packageData, setPackageData] = useState(null);

  const fetchPackageData = () => {
    setLoading(true);
    getPackageDomasticData()
      .then((response) => {
        setPackageData(response);
      })
      .catch((error) => {
        setError(
          error.message || "An error occurred while fetching package data."
        );
      })
      .finally(() => {
        setLoading(false);
      });
  };
  useEffect(() => {
    fetchPackageData();
  }, []);

  return (
    <>
      <div className="Vacation-area ptb-70 mt-2">
        <div className="container">
          <div className="section-title">
            <div>
              <h3>Affordable Domestic Holidays</h3>
              <span className="top-title">
                Enjoy hassle free bookings with <b>SuperbWorldTrip.com</b>
              </span>
            </div>
            {/* <a href="#">View All Package</a> */}
          </div>

          <Row gutter={16} className="g-lg-4 gy-5 mb-70">
            {packageData?.length > 0 ? (
              packageData?.slice(0, 6).map((pkg, index) => (
                <Col key={index} lg={8} md={12} xs={24}>
                  <div className="package-card">
                    <div className="package-card-img-wrap">
                      <Link
                        to={`/package-details/${pkg?.slug}`}
                        aria-label={pkg?.package_name}
                        className="card-img"
                      >
                        <img
                          rel="preload"
                          as="image"
                          src={getImageUrl(pkg.package_gallery?.[0], 'HOME')}
                          alt={pkg.package_name}
                          className="Holiday-images"
                          height={"190px"}
                          width={"100%"}
                          type="image/avif"
                          fetchpriority="high"
                        />
                      </Link>
                      <div className="batch">
                        <span className="date">{`${pkg.package_duration}D/${pkg.package_duration - 1
                          }N`}</span>
                        <div className="location">
                          <svg
                            width="1em"
                            height="1em"
                            viewBox="-1.5 0 15 15"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="#000000"
                          >
                            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                            <g
                              id="SVGRepo_tracerCarrier"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            ></g>
                            <g id="SVGRepo_iconCarrier">
                              {" "}
                              <path
                                fill="#000000"
                                fillRule="evenodd"
                                d="M574,120 C575.324428,120 580,114.054994 580,110.833333 C580,107.611672 577.313708,105 574,105 C570.686292,105 568,107.611672 568,110.833333 C568,114.054994 572.675572,120 574,120 Z M574,113.333333 C575.420161,113.333333 576.571429,112.214045 576.571429,110.833333 C576.571429,109.452621 575.420161,108.333333 574,108.333333 C572.579839,108.333333 571.428571,109.452621 571.428571,110.833333 C571.428571,112.214045 572.579839,113.333333 574,113.333333 Z"
                                transform="translate(-568 -105)"
                              ></path>{" "}
                            </g>
                          </svg>
                          <div className="location-list">
                            <a href="">{pkg.package_country}</a>
                            <FaExchangeAlt className="mx-2" />
                            <a href="">{pkg.package_destination}</a>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="package-card-content">
                      <div className="card-content-top">
                        <Tooltip title={pkg?.package_name}>
                          <h2 className="mb-0">{pkg?.package_name}</h2>
                        </Tooltip>
                        {/* <div className="location-area">
                                                    <ul className="location-list scrollTextAni">
                                                        {pkg?.package_categories?.map((item) => (
                                                            <span key={item.id}>{item?.name}</span>
                                                        ))}
                                                    </ul>
                                                </div> */}
                      </div>

                      <div className="card-content-bottom">
                        <div className="price-area">
                          <span>Starting From:</span>
                          <h3>₹{Math.round(pkg.package_price)}</h3>
                          <p>TAXES INCL/PERS</p>
                        </div>

                        <Link
                          to={`/package-details/${pkg?.slug}`}
                          aria-label="Book Now"
                          className="btn btn-primary d-flex align-items-center gap-1 px-3"
                        >
                          Explore Now{" "}
                        </Link>
                      </div>
                      <div className="bg-light border rounded d-flex align-items-center gap-2 justify-content-between py-2 px-2 mt-2">
                        <div
                          className="text-center"
                          style={{ fontSize: "20px" }}
                        >
                          <FaHotel />
                          {pkg.package_hotel ? (
                            <p
                              style={{
                                color: "green",
                                transition: "color 0.3s ease",
                              }}
                            >
                              Included
                            </p>
                          ) : (
                            <p
                              style={{
                                color: "#dc3545",
                                transition: "color 0.3s ease",
                              }}
                            >
                              Not Include
                            </p>
                          )}
                        </div>
                        <div
                          className="text-center"
                          style={{ fontSize: "20px" }}
                        >
                          <FaBus />
                          {pkg.package_transport ? (
                            <p
                              style={{
                                color: "green",
                                transition: "color 0.3s ease",
                              }}
                            >
                              Included
                            </p>
                          ) : (
                            <p
                              style={{
                                color: "#dc3545",
                                transition: "color 0.3s ease",
                              }}
                            >
                              Not Include
                            </p>
                          )}
                        </div>
                        <div
                          className="text-center"
                          style={{ fontSize: "20px" }}
                        >
                          <svg
                            fill="#000000"
                            height="20px"
                            width="20px"
                            version="1.2"
                            baseProfile="tiny"
                            id="Layer_1"
                            xmlns="http://www.w3.org/2000/svg"
                            xmlnsXlink="http://www.w3.org/1999/xlink"
                            viewBox="0 0 256 256"
                            xmlSpace="preserve"
                          >
                            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                            <g
                              id="SVGRepo_tracerCarrier"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            ></g>
                            <g id="SVGRepo_iconCarrier">
                              {" "}
                              <path
                                id="XMLID_3_"
                                d="M198.5,127h56.8c-3.1,51.4-36.3,94.5-82.3,111.7V256H83v-17.3C37,221.5,3.8,178.4,0.7,127h155.1l87.5-68.1 c3.5-2.7,8.5-2.1,11.2,1.4s2.1,8.5-1.4,11.2c-0.1,0.1-0.3,0.2-0.4,0.3l-81,55.1l73-36.2c4-2,8.8-0.3,10.7,3.6c2,4,0.3,8.8-3.6,10.7 c-0.2,0.1-0.3,0.2-0.5,0.2L198.5,127z M163.6,79.4c0,7.8,3.2,12,5.7,15.3c0.7,1,1.4,1.9,2,2.8c0.9,1.4,2.3,2.1,3.8,2.1 c0.8,0,1.6-0.2,2.4-0.7c2.1-1.3,2.8-4.1,1.5-6.2c-0.8-1.3-1.7-2.4-2.5-3.5c-2.2-3-3.9-5.1-3.9-9.9c0-4.8,1.6-6.9,3.9-9.9 c2.5-3.3,5.7-7.5,5.7-15.3s-3.2-12-5.7-15.3l-0.5-0.6c-1.5-2-4.3-2.4-6.3-0.9c-2,1.5-2.4,4.3-0.9,6.3l0.5,0.6c2.2,3,3.9,5.1,3.9,9.9 c0,4.8-1.6,6.9-3.9,9.9C166.7,67.4,163.6,71.6,163.6,79.4z M115.7,71c0,11.2,4.4,16.9,8.3,22c1.2,1.5,2.2,2.9,3.2,4.5 c0.9,1.4,2.3,2.1,3.8,2.1c0.8,0,1.6-0.2,2.4-0.7c2.1-1.3,2.8-4.1,1.5-6.2c-1.2-1.9-2.5-3.6-3.7-5.2c-3.4-4.5-6.4-8.4-6.4-16.5 s3-12,6.4-16.5c3.9-5.1,8.3-10.8,8.3-22c0-11.1-4.4-16.9-8.3-22l-0.7-0.9c-1.5-2-4.3-2.4-6.3-0.9c-2,1.5-2.4,4.3-0.9,6.3l0.7,1 c3.4,4.5,6.4,8.4,6.4,16.5c0,8.1-3,12-6.4,16.5C120.1,54.1,115.7,59.9,115.7,71z M72.9,79.4c0,7.8,3.2,12,5.7,15.3 c0.7,1,1.4,1.9,2,2.8c0.9,1.4,2.3,2.1,3.8,2.1c0.8,0,1.6-0.2,2.4-0.7c2.1-1.3,2.8-4.1,1.5-6.2c-0.8-1.3-1.7-2.4-2.5-3.5 c-2.2-3-3.9-5.1-3.9-9.9c0-4.8,1.6-6.9,3.9-9.9c2.5-3.3,5.7-7.5,5.7-15.3c0-7.8-3.2-12-5.7-15.3l-0.5-0.6c-1.5-2-4.3-2.4-6.3-0.9 c-2,1.5-2.4,4.3-0.9,6.3l0.5,0.6c2.2,3,3.9,5.1,3.9,9.9c0,4.8-1.6,6.9-3.9,9.9C76.1,67.4,72.9,71.6,72.9,79.4z"
                              ></path>{" "}
                            </g>
                          </svg>
                          {pkg.package_meal ? (
                            <p
                              style={{
                                color: "green",
                                transition: "color 0.3s ease",
                              }}
                            >
                              Included
                            </p>
                          ) : (
                            <p
                              style={{
                                color: "#dc3545",
                                transition: "color 0.3s ease",
                              }}
                            >
                              Not Include
                            </p>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </Col>
              ))
            ) : (
              <div>No packages available.</div>
            )}
          </Row>
        </div>
      </div>
    </>
  );
};

export default AffordableDomesticHolidays;
